import React from 'react'
import { Link } from '@reach/router'
import _ from 'common-tools/LodashHelper'
import { ah, ReduxWrapper, compose } from 'common-data/datahelpers'

const getClassNames = (isCurrent, isPartiallyCurrent, exact, className, activeClassName) => {
  let cls = [
    className
  ]
  if (exact) {
    if (isCurrent) {
      cls.push(activeClassName)
    }
  } else if (isCurrent || isPartiallyCurrent) {
    cls.push(activeClassName)
  }
  return _.join(cls, ' ')
}

export const RouteLinkPlain = ({ children, wrapperClassName, stopBubbleClicks, activeClassName, className, exact, addLayoutBreadCrumbKey, breadCrumbKey, pin, setpin, ...rest }) => {
  return <span className={wrapperClassName || ''}
    onClick={(e) => {
      if (stopBubbleClicks) {
        e.preventDefault()
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
      }
      if (breadCrumbKey) {
        addLayoutBreadCrumbKey(breadCrumbKey.key, breadCrumbKey.value, breadCrumbKey.disabled)
      }
    }}
  >
    <Link {...rest} getProps={({ isCurrent, isPartiallyCurrent }) => {
      return {
        className: getClassNames(isCurrent, isPartiallyCurrent, exact, className, activeClassName)
      }
    }} >{children}</Link>
  </span>
}

export const RouteLink = compose(
  ReduxWrapper([
  ], [
    ah.addLayoutBreadCrumbKey
  ])
)(RouteLinkPlain)
